<template>
  <div class="dashboard-container p-4">
    <div class="bg-white p-5 rounded-lg shadow mb-4">
      <h1 class="text-2xl font-bold text-gray-800">
        Crew Dashboard
      </h1>
      <p class="text-gray-600">
        Welcome to your crew management dashboard!
      </p>
    </div>
        
    <!-- Quick Actions Card -->
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
      <Card class="shadow-sm">
        <template #title>
          <div class="flex items-center">
            <i class="pi pi-calendar mr-2 text-blue-500" />
            <span>Upcoming Shifts</span>
          </div>
        </template>
        <template #content>
          <div class="p-4">
            <p class="mb-3">
              You have <span class="font-bold text-blue-600">3</span> upcoming shifts this week.
            </p>
            <Button
              label="View Schedule"
              icon="pi pi-calendar"
              severity="secondary"
            />
          </div>
        </template>
      </Card>
            
      <Card class="shadow-sm">
        <template #title>
          <div class="flex items-center">
            <i class="pi pi-id-card mr-2 text-green-500" />
            <span>My Profile</span>
          </div>
        </template>
        <template #content>
          <div class="p-4">
            <p class="mb-3">
              Update your qualifications and availability.
            </p>
            <Button
              label="Manage Profile"
              icon="pi pi-user-edit"
              severity="secondary"
            />
          </div>
        </template>
      </Card>
            
      <Card class="shadow-sm">
        <template #title>
          <div class="flex items-center">
            <i class="pi pi-cog mr-2 text-orange-500" />
            <span>Equipment Requests</span>
          </div>
        </template>
        <template #content>
          <div class="p-4">
            <p class="mb-3">
              Submit requests for your upcoming jobs.
            </p>
            <Button
              label="Request Equipment"
              icon="pi pi-plus"
              severity="secondary"
            />
          </div>
        </template>
      </Card>
    </div>
        
    <!-- Crew Schedule Timeline -->
    <div class="bg-white p-5 rounded-lg shadow mb-4">
      <h2 class="text-xl font-semibold mb-4">
        Your Schedule
      </h2>
      <Timeline
        :value="scheduleEvents"
        layout="horizontal"
        align="top"
      >
        <template #content="slotProps">
          <div class="text-sm">
            <div class="font-bold mb-1">
              {{ slotProps.item.name }}
            </div>
            <div class="text-gray-600">
              {{ slotProps.item.date }}
            </div>
            <div class="mt-2">
              {{ slotProps.item.location }}
            </div>
          </div>
        </template>
        <template #opposite>
          <span />
        </template>
        <template #marker="slotProps">
          <span
            class="flex w-8 h-8 items-center justify-center rounded-full"
            :class="slotProps.item.color"
          >
            <i :class="slotProps.item.icon" />
          </span>
        </template>
      </Timeline>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';

// Sample schedule events
const scheduleEvents = ref([
    { 
        name: 'Corporate Event', 
        date: 'May 20, 2023 - 8AM',
        location: 'Convention Center', 
        icon: 'pi pi-briefcase',
        color: 'bg-blue-500 text-white' 
    },
    { 
        name: 'Concert Setup', 
        date: 'May 22, 2023 - 6AM',
        location: 'Arena Downtown', 
        icon: 'pi pi-volume-up',
        color: 'bg-green-500 text-white' 
    },
    { 
        name: 'Wedding Event', 
        date: 'May 25, 2023 - 10AM',
        location: 'Grand Hotel', 
        icon: 'pi pi-heart',
        color: 'bg-pink-500 text-white' 
    },
    { 
        name: 'Festival Support', 
        date: 'May 28, 2023 - 7AM',
        location: 'City Park', 
        icon: 'pi pi-users',
        color: 'bg-purple-500 text-white' 
    }
]);
</script>

<style scoped>
.dashboard-container {
    background-color: #f5f7fa;
    min-height: 100vh;
}
</style> 